import React from "react";
import { Loading } from '../shared/constants/texts.js';

export const Technologies = (props) => {

  return (
    <div id="technologies" style={{ 
      padding: '50px 0',
      background: 'linear-gradient(180deg, #f8fafc 0%, #ffffff 100%)'
    }}>
      <div className="container">
        <div className="section-title">
          <h2>Tecnologias e Ferramentas</h2>
          <p>
            Trabalhamos com as principais tecnologias do mercado para desenvolver 
            soluções modernas, escaláveis e de alta performance.
          </p>
        </div>
        
        <div className="row">
          {props.data ?          
          props.data.map((tech, index) => (
            <div 
              key={`tech-${index}`} 
              className="col-md-3 col-sm-4 col-xs-6"
              style={{ marginBottom: '20px' }}
            >
              <div style={{
                padding: '20px 15px',
                background: '#fff',
                borderRadius: '12px',
                border: '1px solid #e2e8f0',
                transition: 'all 0.3s ease',
                textAlign: 'center',
                cursor: 'pointer'
              }}
              className="tech-card"
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.boxShadow = '0 12px 24px rgba(0,0,0,0.1)';
                e.currentTarget.style.borderColor = tech.color;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.borderColor = '#e2e8f0';
              }}
              >
                <i 
                  className={tech.icon}
                  style={{
                    fontSize: '32px',
                    color: tech.color,
                    marginBottom: '10px',
                    display: 'block'
                  }}
                ></i>
                <h4 style={{
                  fontSize: '15px',
                  fontWeight: '700',
                  color: '#1e293b',
                  marginBottom: '4px'
                }}>
                  {tech.name}
                </h4>
                <p style={{
                  fontSize: '10px',
                  color: '#64748b',
                  margin: 0,
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  fontWeight: '600'
                }}>
                  {tech.category}
                </p>
              </div>
            </div>
          )): Loading}
        </div>

        <div className="row" style={{ marginTop: '20px' }}>
          <div className="col-md-12 text-center">
            <p style={{
              fontSize: '14px',
              color: '#475569',
              maxWidth: '650px',
              margin: '0 auto'
            }}>
              Nossa equipe está sempre atualizada com as melhores práticas do desenvolvimento de software.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
